type COMP_FIELDS_KEY = `COMP${number}_${string}`;
type COMP_FIELDS_VALUE = `COMP${number}`;
type COMP_ARRAYS_VALUE = `COMP${number}_${string}`;

export const COMP_FIELDS = {
  COMP1_accountNo: 'COMP1',
  COMP2_plan: 'COMP2',
  COMP3_guarantee: 'COMP3',
  COMP4_productType: 'COMP4',
  COMP5_balance: 'COMP5',
  COMP6_totalInvestmentsCount: 'COMP6',
  COMP7_benevaGuaranteedInvestmentFundsCount: 'COMP7',
  COMP8_benevaGuaranteedInvestmentFundCode: 'COMP8',
  COMP9_benevaGuaranteedInvestmentFundNameCode: 'COMP9',
  COMP10_benevaGuaranteedInvestmentFundFeeType: 'COMP10',
  COMP11_benevaGuaranteedInvestmentFundBalance: 'COMP11',
  COMP12_benevaInvestmentAccountsCount: 'COMP12',
  COMP13_benevaInvestmentAccountFundCode: 'COMP13',
  COMP14_benevaInvestmentAccountFundNameCode: 'COMP14',
  COMP15_benevaInvestmentAccountFeeType: 'COMP15',
  COMP16_benevaInvestmentAccountBalance: 'COMP16',
  COMP17_dailyInterestAccountsCount: 'COMP17',
  COMP18_dailyInterestAccountFundCode: 'COMP18',
  COMP19_dailyInterestAccountBalance: 'COMP19',
  COMP20_highYieldAccountsCount: 'COMP20',
  COMP21_highYieldAccountFundCode: 'COMP21',
  COMP22_highYieldAccountBalance: 'COMP22',
  COMP23_guaranteedInterestAccountsCount: 'COMP23',
  COMP24_guaranteedInterestAccountFundCode: 'COMP24',
  COMP25_guaranteedInterestAccountCertificateNo: 'COMP25',
  COMP26_guaranteedInterestAccountRedeemableFlag: 'COMP26',
  COMP27_guaranteedInterestAccountMaturityDate: 'COMP27',
  COMP28_guaranteedInterestAccountBalance: 'COMP28',
  COMP29_guaranteedInterestAccountIsWaitingIssueFlag: 'COMP29',
  COMP30_beneficiariesCount: 'COMP30',
  COMP31_beneficiaryFirstName: 'COMP31',
  COMP32_beneficiaryLastName: 'COMP32',
  COMP33_beneficiaryRevocableFlag: 'COMP33',
  COMP34_pacCount: 'COMP34',
  COMP35_pacAmount: 'COMP35',
  COMP36_pacDepositFrequency: 'COMP36',
  COMP37_pacStatus: 'COMP37',
  COMP38_pacSplitOption: 'COMP38',
  COMP39_pacCount: 'COMP39',
  COMP40_pacBankAccountHolder: 'COMP40',
  COMP41_pacBankAccountBankNo: 'COMP41',
  COMP42_pacBankAccountTransit: 'COMP42',
  COMP43_pacBankAccountFolio: 'COMP43',
  COMP44_pacInvestmentInstructionsCount: 'COMP44',
  COMP45_pacBenevaInvestmentAccountsCount: 'COMP45',
  COMP46_pacBenevaInvestmentAccountFundCode: 'COMP46',
  COMP47_pacBenevaInvestmentAccountFeeType: 'COMP47',
  COMP48_pacBenevaInvestmentAccountAmount: 'COMP48',
  COMP49_pacDailyInterestAccountsCount: 'COMP49',
  COMP50_pacDailyInterestAccountFundCode: 'COMP50',
  COMP51_pacDailyInterestAccountAmount: 'COMP51',
  COMP52_pacHighYieldAccountsCount: 'COMP52',
  COMP53_pacHighYieldAccountFundCode: 'COMP53',
  COMP54_pacHighYieldAccountAmount: 'COMP54',
  COMP55_pacBenevaGuaranteedInvestmentFundsCount: 'COMP55',
  COMP56_pacBenevaGuaranteedInvestmentFundFundCode: 'COMP56',
  COMP57_pacBenevaGuaranteedInvestmentFundFeeType: 'COMP57',
  COMP58_pacBenevaGuaranteedInvestmentFundAmount: 'COMP58',
  COMP59_payrollDeduction: 'COMP59',
  COMP60_pacBenevaInvestmentAccountFundNameCode: 'COMP60',
  COMP61_pacBenevaGuaranteedInvestmentFundNameCode: 'COMP61',
  COMP62_hasMultiplePacs: 'COMP62',
  COMP63_spousalFlag: 'COMP63',
  COMP64_purchaserMemberContractholder: 'COMP64',
  COMP65_fab: 'COMP65',
} as const satisfies Record<COMP_FIELDS_KEY, COMP_FIELDS_VALUE>;

export const COMP_ARRAYS = {
  COMP7_benevaGuaranteedInvestmentFunds: 'COMP7_benevaGuaranteedInvestmentFunds',
  COMP12_benevaInvestmentAccounts: 'COMP12_benevaInvestmentAccounts',
  COMP17_dailyInterestAccounts: 'COMP17_dailyInterestAccounts',
  COMP20_highYieldAccounts: 'COMP20_highYieldAccounts',
  COMP23_guaranteedInterestAccounts: 'COMP23_guaranteedInterestAccounts',
  COMP30_beneficiaries: 'COMP30_beneficiaries',
  COMP34_pac: 'COMP34_pac',
  COMP45_pacBenevaInvestmentAccounts: 'COMP45_pacBenevaInvestmentAccounts',
  COMP49_pacDailyInterestAccounts: 'COMP49_pacDailyInterestAccounts',
  COMP52_pacHighYieldAccounts: 'COMP52_pacHighYieldAccounts',
  COMP55_pacBenevaGuaranteedInvestmentFunds: 'COMP55_pacBenevaGuaranteedInvestmentFunds',
} as const satisfies Record<COMP_FIELDS_KEY, COMP_ARRAYS_VALUE>;

export const ALL_COMP_ARRAYS = Object.values(COMP_ARRAYS);

export type COMP_ARRAY = (typeof ALL_COMP_ARRAYS)[number];

export type CompFieldValue = (typeof COMP_FIELDS)[keyof typeof COMP_FIELDS];
